import PropTypes from 'prop-types';

export const ProviderAccountPropType = PropTypes.shape({
  sellerLabelProviderId: PropTypes.string,
  providerName: PropTypes.string,
  nickname: PropTypes.string,
  accountNumber: PropTypes.string,
  isPrimaryAccount: PropTypes.bool,
});

/**
 * @typedef {object} ProviderAccountPropType
 * @property {string} sellerLabelProviderId
 * @property {string} providerName
 * @property {string} nickname
 * @property {string} accountNumber
 * @property {boolean} isPrimaryAccount
 */
